export default [
    {
        path: '/media-library/tag',
        props: true,
        component: () => import('@/views/MediaLibrary/Tag'),
    },
];
